import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-data-table-page-configurator',
	templateUrl:'./DataTablePageConfiguratorPluginCompPage.html',
	styles: [],
	styleUrls:['./DataTablePageConfiguratorPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class DataTablePageConfiguratorPluginCompPage
{
	mdContent_894 = `\`\`\`java
import com.jwebmp.plugins.datatable.DataTablePageConfigurator;
\`\`\``;
}
